import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updatePositionType } from "common/services/payments.service";
import Form from "./Form";
import { toast } from "react-toastify";

const UpdatePositionType: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
  selectedRecord: any;
}> = ({ toggle, isModalOpen, fetchData, selectedRecord }) => {
  const [loading, setLoading] = useState<boolean>(false);
  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: selectedRecord?.name,
      category: {
        value: selectedRecord?.category?.id || "",
        label: selectedRecord?.category?.name || "",
      },
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
      category: Yup.object().shape({
        value: Yup.string(),
        label: Yup.string(),
      }),
    }),
    onSubmit: async (values: any) => {
      const data = {
        id: selectedRecord?.id,
        data: {
          name: values["name"] ? values["name"].trim() : null,
          category: values["category"]["value"] || null,
        },
      };

      setLoading(true);
      try {
        await updatePositionType(selectedRecord?.id, data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("Position type updated successfully", {});
      } catch (e: any) {
        toast.error("Position type update failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Position Type
      </ModalHeader>

      <Form
        validation={validation}
        isUpdate
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default UpdatePositionType;
